/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import {
  Grid,
  Typography,
  makeStyles,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import TodayIcon from '@material-ui/icons/Today';
import CloseIcon from '@material-ui/icons/Close';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { useParams } from 'react-router';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import DatePicker from 'components/DatePicker';
import { formatDateToYearMouthDay, cyrb53Hash } from 'utils/helpers';
import { getFlavorDisplayName } from 'utils/flavorDisplay';
import TitleBehavior from 'containers/Environments/Configuration/FormBehavior/TitleBehavior';
import {
  exportHistoryMonitoringCSVRequest,
  getMonitoringHistoryRequest,
} from 'modules/environments/actions';
import {
  ListEnvironmentHistoryProps,
  ListEnvironmentHistoryFields,
  ZeroTrustStateProps,
} from 'modules/environments/interfaces';

import { formatDateValue } from 'utils/dateFormat';
import { ModalFields } from 'modules/modal/interfaces';
import { modalOpen, modalClose } from 'modules/modal/actions';
import DynamicFilter from 'components/DynamicFilter';
import VerifiedUserTwoToneIcon from '@material-ui/icons/VerifiedUserTwoTone';
import SecurityTwoToneIcon from '@material-ui/icons/SecurityTwoTone';
import WarningTwoToneIcon from '@material-ui/icons/WarningTwoTone';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTableFilters } from 'hooks/useTableFilters';
import Button from 'components/Button';
import { Formik } from 'formik';
import { FilterFields } from 'modules/filters/interfaces';
import palette from 'theme/palette';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { setFilterValues } from 'modules/filters/actions';
import clsx from 'clsx';
import { convertSecondsToMinutes } from 'utils/tsHelpers';
import styles from '../styles';
import { filterOptions } from './dynamicFilterOptions';
import { formatOperationalTimingBaseline } from './helpers';

const useStyles = makeStyles(styles);

interface DatesProps {
  start_date: string;
  end_date: string;
}

const initialQuery = {
  offset: 0,
  limit: 10,
  search: '',
};

interface Props {
  isLoading: boolean;
  monitoringHistory: ListEnvironmentHistoryProps;
  filters: FilterFields[];
  environmentName?: string;
  getMonitoringHistoryRequest: (props) => void;
  modalOpen: (props: ModalFields) => void;
  modalClose: () => void;
  setFilterValues: (props: FilterFields[]) => void;
  exportHistoryMonitoringCSVRequest: ({ id, filename }) => void;
}

const MonitoringHistory = ({
  isLoading,
  monitoringHistory,
  filters,
  environmentName,
  getMonitoringHistoryRequest,
  modalOpen,
  modalClose,
  setFilterValues,
  exportHistoryMonitoringCSVRequest,
}: Props) => {
  const classes = useStyles();

  const {
    itemOrder,
    setQuery,
    query,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
    searchValue,
  } = useTableFilters(initialQuery);
  const [refresh, setRefresh] = React.useState(false);
  const { id } = useParams<{ id: string }>();

  const [dateFilter, setDateFilter] = React.useState(true);

  const [dates, setDates] = React.useState<DatesProps>({
    start_date: '',
    end_date: '',
  });

  const handleSubmit = (values: DatesProps) => {
    setDates({
      start_date: formatDateToYearMouthDay(values?.start_date),
      end_date: formatDateToYearMouthDay(values?.end_date),
    });
  };
  const [headers] = React.useState([
    {
      key: 'monitoring_type',
      i18n: 'MONITORING_PAGE.TYPE_KEY',
      order: true,
    },
    {
      key: 'created_at',
      i18n: 'MONITORING_PAGE.DATE_TIME_KEY',
      order: true,
      centerTitle: true,
    },
    {
      key: 'instance',
      i18n: 'INSTANCE_KEY',
      order: true,
    },
    {
      key: 'vacancies_count',
      i18n: 'MONITORING_PAGE.VACANCIES_KEY',
      order: true,
      centerTitle: true,
      style: { width: 70 },
    },
    {
      key: 'licenses_count',
      i18n: 'MONITORING_PAGE.LICENSES_KEY',
      style: { width: 70 },
      order: true,
      centerTitle: true,
    },
    {
      key: 'connected_users_count',
      i18n: 'MONITORING_PAGE.SESSIONS_KEY',
      style: { width: 70 },
      order: true,
      centerTitle: true,
    },
    {
      key: '',
      i18n: 'CLIENT_DATA_SUMMARY_KEY',
    },
    {
      key: '',
      i18n: 'MONITORING_PAGE.DETAILS_KEY',
      centerTitle: true,
    },
  ]);

  const filterValues = React.useMemo(() => {
    return filters?.reduce(
      (acc, { key, value }) => ({ ...acc, [key]: value || '' }),
      {} as { [key: string]: string }
    );
  }, [filters]);

  React.useEffect(() => {
    setQuery(prev => ({ ...prev, ...filterValues }));
  }, [filterValues, setQuery]);

  const ZeroTrustIcon = ({ status }: ZeroTrustStateProps) => {
    const classes = useStyles();
    const map = {
      enabled: (
        <Tooltip
          arrow
          title={i18n.t('ZERO_TRUST_ENABLED_KEY')}
          className={classes.tooltip}
        >
          <VerifiedUserTwoToneIcon className={classes.enabledZeroTrust} />
        </Tooltip>
      ),
      grace_period: (
        <Tooltip
          arrow
          title={i18n.t('ZERO_TRUST_GRACE_PERIOD_KEY')}
          className={classes.tooltip}
        >
          <SecurityTwoToneIcon className={classes.startingZeroTrust} />
        </Tooltip>
      ),
      failed: (
        <Tooltip
          arrow
          title={i18n.t('ZERO_TRUST_FAILED_KEY')}
          className={classes.tooltip}
        >
          <SecurityTwoToneIcon className={classes.failedZeroTrust} />
        </Tooltip>
      ),
      starting: (
        <Tooltip
          arrow
          title={i18n.t('ZERO_TRUST_STARTING_KEY')}
          className={classes.tooltip}
        >
          <SecurityTwoToneIcon className={classes.startingZeroTrust} />
        </Tooltip>
      ),
      disabled: (
        <Tooltip
          arrow
          title={i18n.t('ZERO_TRUST_DISABLED_KEY')}
          className={classes.tooltip}
        >
          <SecurityTwoToneIcon className={classes.disabledZeroTrust} />
        </Tooltip>
      ),
    };

    if (status === null) {
      return (
        <Tooltip
          arrow
          title={i18n.t('ZERO_TRUST_WRONG_VERSION_KEY')}
          className={classes.tooltip}
        >
          <WarningTwoToneIcon className={classes.failedZeroTrust} />
        </Tooltip>
      );
    }

    return map[status] || null;
  };

  const getMonitoringHistory = (refresh = false) => {
    getMonitoringHistoryRequest({
      id,
      query,
      start_date: dates.start_date,
      end_date: dates.end_date,
    });
    setRefresh(refresh);
  };

  React.useEffect(() => {
    getMonitoringHistory();
  }, [id, query, dates]);

  const monitoringTypeEnum = {
    type_instances_operational_timing: i18n.t(
      'MONITORING_PAGE.OPERATING_TIME_KEY'
    ),
    scale_instances_timeout_sessions: i18n.t(
      'BLOCK_INSTANCES_WITH_SESSIONS_TIMEOUT_KEY'
    ),
  };

  const handleOpenOperationTimeDetails = (
    item: ListEnvironmentHistoryFields
  ) => {
    const baseline = formatOperationalTimingBaseline(item);

    modalOpen({
      title: monitoringTypeEnum[item?.monitoring_type],
      maxWidth: 'md',
      content: (
        <>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('MONITORING_PAGE.OPERATING_TIME_LIMIT_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {baseline.limit}
            </Typography>
          </Grid>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('MONITORING_PAGE.HISTORICAL_MEDIAN_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {baseline.median}
            </Typography>
          </Grid>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('MONITORING_PAGE.SAMPLE_COUNT_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {baseline.samples}
            </Typography>
          </Grid>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('MONITORING_PAGE.AVERAGE_OPERATING_TIME_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {convertSecondsToMinutes(
                item?.instance_details?.seconds_spent_to_operational_or_alert
              )}
            </Typography>
          </Grid>

          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('MONITORING_PAGE.ALERTED_INSTANCES_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {item?.instance_id}
            </Typography>
          </Grid>
        </>
      ),
      genericFooter: {
        action: () => {
          modalClose();
        },
        label: i18n.t('CLOSE_KEY'),
      },
    });
  };

  const handleOpenSessionsTimeoutDetails = (
    item: ListEnvironmentHistoryFields
  ) => {
    modalOpen({
      title: monitoringTypeEnum[item?.monitoring_type],
      maxWidth: 'md',
      content: (
        <>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('FLAVOR_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {getFlavorDisplayName(item?.instance_details?.flavor)}
            </Typography>
          </Grid>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('REGION_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {item?.instance_details?.region}
            </Typography>
          </Grid>
          {item?.instance_details?.platform_version !== null &&
            item?.instance_details?.platform_version !== undefined && (
              <Grid container>
                <Typography className={classes.detailsTextTitle}>
                  {`${i18n.t('PLATFORM_VERSION_NUMBER_KEY')}: `}
                </Typography>
                <Typography className={classes.detailsText}>
                  {item?.instance_details?.platform_version}
                </Typography>
              </Grid>
            )}
          {item?.instance_details?.zero_trust_state !== null &&
            item?.instance_details?.zero_trust_state !== undefined && (
              <Grid container>
                <Typography className={classes.detailsTextTitle}>
                  {`${i18n.t('STATUS_ZERO_TRUST_KEY')}: `}
                </Typography>
                <Typography className={classes.detailsText}>
                  <ZeroTrustIcon
                    status={item?.instance_details?.zero_trust_state}
                  />
                </Typography>
              </Grid>
            )}
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('SPENT_SECONDS_TO_OPERATIONAL_ALERT_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {convertSecondsToMinutes(
                item?.instance_details?.seconds_spent_to_operational_or_alert
              )}
            </Typography>
          </Grid>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('EXPIRED_SESSIONS_KEY')}: `}
            </Typography>
            <Typography className={classes.detailsText}>
              {item?.instance_details?.expired_sessions}
            </Typography>
          </Grid>
          <Grid container>
            <Typography className={classes.detailsTextTitle}>
              {`${i18n.t('BLOCKED_BY_MONITORING_KEY')}: `}
            </Typography>
            <Typography
              className={clsx({
                [classes.detailsTextTitleYes]:
                  item?.instance_details?.blocked_by_monitoring,
                [classes.detailsTextTitleNo]:
                  item?.instance_details?.blocked_by_monitoring === false,
              })}
            >
              {item?.instance_details?.blocked_by_monitoring
                ? i18n.t('YES_KEY')
                : i18n.t('NO_KEY')}
            </Typography>
          </Grid>
        </>
      ),
      genericFooter: {
        action: () => {
          modalClose();
        },
        label: i18n.t('CLOSE_KEY'),
      },
    });
  };

  const formatMonitoringDetails = item => {
    if (item.monitoring_type === 'type_instances_operational_timing') {
      return `${i18n.t(
        'MONITORING_PAGE.AVERAGE_OPERATING_TIME_KEY'
      )}: ${convertSecondsToMinutes(
        item?.instance_details?.seconds_spent_to_operational_or_alert
      )}`;
    }

    if (
      item.monitoring_type === 'scale_instances_timeout_sessions' &&
      item?.instance_details?.blocked_by_monitoring !== undefined
    ) {
      const status = item?.instance_details?.blocked_by_monitoring
        ? i18n.t('YES_KEY')
        : i18n.t('NO_KEY');
      return `${i18n.t('BLOCKED_BY_MONITORING_KEY')}: ${status}`;
    }

    return '';
  };

  const getMonitoringHistoryListPDF: Array<[
    string,
    string,
    string,
    number,
    number,
    number,
    any
  ]> = monitoringHistory?.results.map(item => [
    monitoringTypeEnum[item?.monitoring_type],
    formatDateValue(item?.created_at),
    item?.instance_id,
    item?.vacancies_count,
    item?.licenses_count,
    item?.instance_details?.sessions_count,
    formatMonitoringDetails(item),
  ]);

  // eslint-disable-next-line new-cap
  const doc = new jsPDF({ orientation: 'landscape' });

  const generatePDFButton = () => {
    doc.setFontSize(12);
    doc.text(
      [
        '',
        `${i18n.t('ENVIRONMENT_NAME_KEY')}: ${environmentName}`,
        `${i18n.t('PDF_GENERATED_AT_KEY')}: ${new Date().toLocaleString(
          'pt-BR',
          {
            hour12: false,
          }
        )}`,
        `${i18n.t('MONITORING_PAGE.HISTORY_SUBTITLE_KEY')}:`,
        '',
      ],
      10,
      10,
      { lineHeightFactor: 1.2, maxWidth: 200 }
    );
    autoTable(doc, {
      head: [
        [
          `${i18n.t('MONITORING_PAGE.TYPE_KEY')}`,
          `${i18n.t('MONITORING_PAGE.DATE_TIME_KEY')}`,
          `${i18n.t('INSTANCE_KEY')}`,
          `${i18n.t('MONITORING_PAGE.VACANCIES_KEY')}`,
          `${i18n.t('MONITORING_PAGE.LICENSES_KEY')}`,
          `${i18n.t('MONITORING_PAGE.SESSIONS_KEY')}`,
          `${i18n.t('CLIENT_DATA_SUMMARY_KEY')}`,
        ],
      ],
      margin: { top: 30 },
      styles: { lineWidth: 0.3, lineColor: palette.borderGray, fontSize: 9 },
      headStyles: {
        fillColor: palette.deepBlue,
        textColor: palette.offWhite,
        fontSize: 9,
      },
      body: getMonitoringHistoryListPDF,
    });
    doc.save(
      `${environmentName}-${new Date().toLocaleString('pt-BR', {
        hour12: false,
      })}.pdf`
    );
  };

  const handleExportHistoryMonitoringCSV = () => {
    modalOpen({
      title: i18n.t('WANT_EXPORT_CSV_KEY'),
      content: i18n.t('EXPORT_CSV_DESCRIPTION_KEY'),
      footer: (
        <Grid>
          <Button
            submitButton
            id="submit-button"
            onClick={() => {
              exportHistoryMonitoringCSVRequest({
                id,
                filename: `${i18n.t(
                  'MONITORING_PAGE.HISTORY_SUBTITLE_KEY'
                )}_${environmentName}`,
              });
              modalClose();
            }}
          >
            {i18n.t('EXPORT_KEY')}
          </Button>
          <Button id="cancel-button" variant="outlined" onClick={modalClose}>
            {i18n.t('CANCEL_KEY')}
          </Button>
        </Grid>
      ),
    });
  };

  React.useEffect(() => {
    setFilterValues(filterOptions);
  }, [filterOptions]);

  return (
    <Grid container>
      <TitleBehavior
        title={i18n.t('HISTORY_SOP_KEY')}
        subtitle={i18n.t('MONITORING_PAGE.HISTORY_SUBTITLE_KEY')}
      />
      <Grid container>
        <Grid container alignItems="center">
          <DynamicFilter
            noSwitchList
            setQuery={setQuery}
            isLoading={isLoading}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleSearch={handleSearch}
            itemsCountFiltered={monitoringHistory?.count}
          />
        </Grid>
      </Grid>

      <Grid container className={classes.filterSelector}>
        <Grid item className={classes.pdfButtonGrid}>
          <Button
            id="generate-pdf-button"
            submitButton
            startIcon={<GetAppIcon />}
            onClick={() => {
              generatePDFButton();
              modalClose();
            }}
          >
            {i18n.t('GENERATE_PDF')}
          </Button>
          <Button
            id="generate-csv-button"
            submitButton
            startIcon={<GetAppIcon />}
            onClick={() => {
              handleExportHistoryMonitoringCSV();
            }}
          >
            {i18n.t('EXPORT_CSV_KEY')}
          </Button>
        </Grid>

        {dateFilter ? (
          <Button
            startIcon={<TodayIcon />}
            variant="outlined"
            onClick={() => setDateFilter(false)}
            className={classes.applyButton}
          >
            {i18n.t('APPLY_DATE_FILTERS_KEY')}
          </Button>
        ) : (
          <>
            <Formik
              initialValues={dates}
              onSubmit={handleSubmit}
              validateOnBlur
              validateOnChange
            >
              {({ setFieldValue, submitForm, values }) => (
                <Grid
                  spacing={2}
                  item
                  justify="flex-end"
                  className={classes.filterButtons}
                >
                  <IconButton
                    onClick={() => {
                      setDateFilter(true);
                      setDates({ start_date: '', end_date: '' });
                      setFieldValue('start_date', null);
                      setFieldValue('end_date', null);
                    }}
                  >
                    <CloseIcon className={classes.closeIcon} />
                  </IconButton>
                  <DatePicker
                    id="start_date"
                    type="datetime"
                    label={i18n.t('START_DATE_KEY')}
                    keyValue="start_date"
                    value={values?.start_date}
                    setFieldsValue={setFieldValue}
                    shrink={
                      values?.start_date !== '' &&
                      values?.start_date !== null &&
                      values?.start_date !== undefined
                    }
                  />
                  <DatePicker
                    id="end_date"
                    type="datetime"
                    label={i18n.t('END_DATE_KEY')}
                    keyValue="end_date"
                    value={values?.end_date}
                    minDate={values?.start_date}
                    setFieldsValue={setFieldValue}
                    shrink={
                      values?.end_date !== '' &&
                      values?.end_date !== null &&
                      values?.end_date !== undefined
                    }
                  />
                  <Grid item className={classes.pdfButtonGrid}>
                    <Button
                      id="submit-button"
                      onClick={submitForm}
                      submitButton
                      disabled={
                        !values?.start_date ||
                        !values?.end_date ||
                        values?.start_date > values?.end_date
                      }
                    >
                      {i18n.t('APPLY_KEY')}
                    </Button>
                    {(values?.start_date || values?.end_date) && (
                      <Button
                        id="clear-button"
                        onClick={() => {
                          setFieldValue('start_date', null);
                          setFieldValue('end_date', null);
                        }}
                        deleteButton
                      >
                        {i18n.t('CLEAR_FORM_KEY')}
                      </Button>
                    )}
                  </Grid>
                </Grid>
              )}
            </Formik>
          </>
        )}
      </Grid>
      <Grid container>
        <TableItems
          header={
            <>
              {headers.map(item => (
                <TableCell
                  key={item?.key}
                  order={item?.order}
                  style={item?.style}
                  centerTitle={item?.centerTitle}
                  handleOrder={() =>
                    item?.order ? handleOrder(item?.key) : null
                  }
                  markOderItem={itemOrder === item?.key}
                >
                  {i18n.t(item?.i18n)}
                </TableCell>
              ))}
            </>
          }
          renderItems={(item: ListEnvironmentHistoryFields, index) => (
            <TableRow key={cyrb53Hash(String(index))}>
              <TableCell className={classes.rowAllRowsCountType}>
                <Tooltip
                  arrow
                  title={monitoringTypeEnum[item?.monitoring_type]}
                  placement="top"
                >
                  <Typography className={classes.detailsTextTableType}>
                    {monitoringTypeEnum[item?.monitoring_type]}
                  </Typography>
                </Tooltip>
              </TableCell>
              <TableCell align="center" centerTitle className={classes.rowDate}>
                {formatDateValue(item?.created_at)}
              </TableCell>
              <TableCell
                copyable
                ellipsis
                maxLength={20}
                style={{ whiteSpace: 'nowrap' }}
              >
                {item?.instance_id}
              </TableCell>
              <TableCell
                align="center"
                centerTitle
                className={classes.rowsCount}
              >
                {item?.vacancies_count}
              </TableCell>
              <TableCell
                align="center"
                centerTitle
                className={classes.rowsCount}
              >
                {item?.licenses_count}
              </TableCell>
              <TableCell
                align="center"
                centerTitle
                className={classes.rowsCount}
              >
                {item?.instance_details?.sessions_count}
              </TableCell>
              <TableCell
                align="center"
                centerTitle
                className={classes.rowAllRowsCount}
              >
                <Grid container>
                  <Grid container className={classes.summary}>
                    {item.monitoring_type ===
                      'type_instances_operational_timing' && (
                      <>
                        <Typography className={classes.detailsTextTable}>
                          {`${i18n.t(
                            'MONITORING_PAGE.AVERAGE_OPERATING_TIME_KEY'
                          )}: `}
                          {`${convertSecondsToMinutes(
                            item?.instance_details
                              .seconds_spent_to_operational_or_alert
                          )}`}
                        </Typography>
                      </>
                    )}
                    {item.monitoring_type ===
                      'scale_instances_timeout_sessions' &&
                      item?.instance_details?.blocked_by_monitoring !==
                        undefined && (
                        <>
                          <Typography className={classes.detailsTextTable}>
                            {`${i18n.t('BLOCKED_BY_MONITORING_KEY')}: `}
                          </Typography>
                          <Typography
                            className={clsx({
                              [classes.detailsTextYes]:
                                item?.instance_details?.blocked_by_monitoring,
                              [classes.detailsTextNo]:
                                item?.instance_details
                                  ?.blocked_by_monitoring === false,
                            })}
                          >
                            {item?.instance_details?.blocked_by_monitoring
                              ? i18n.t('YES_KEY')
                              : i18n.t('NO_KEY')}
                          </Typography>
                        </>
                      )}
                  </Grid>
                </Grid>
              </TableCell>
              <TableCell centerTitle align="center">
                <InfoOutlinedIcon
                  onClick={() => {
                    if (
                      item.monitoring_type ===
                      'type_instances_operational_timing'
                    ) {
                      handleOpenOperationTimeDetails(item);
                    }
                    if (
                      item.monitoring_type ===
                      'scale_instances_timeout_sessions'
                    ) {
                      handleOpenSessionsTimeoutDetails(item);
                    }
                  }}
                  className={classes.defaultIcon}
                />
              </TableCell>
            </TableRow>
          )}
          data={monitoringHistory}
          overrideRowsCount={query.limit}
          isLoading={!refresh && isLoading}
          onChangePage={handlePageChange}
          onChangeLimit={handleLimitChange}
          notFoundText={i18n.t('MONITOR.NO_RESULTS_INSTANCES')}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { companySelected, data },
  environments: { monitoringHistory, isLoading },
  filters: { filters },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
  isLoading,
  monitoringHistory,
  filters,
});

export default connect(mapStateToProps, {
  getMonitoringHistoryRequest,
  modalOpen,
  modalClose,
  setFilterValues,
  exportHistoryMonitoringCSVRequest,
})(MonitoringHistory);
